import React, { useState } from 'react'
import { Edit3, MapPin, Phone, Mail, User, Building, MessageCircle } from 'lucide-react'

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e) => {
    // Handle form submission here
    console.log('Form submitted:', formData)
    // You can add form validation and API call here
    alert('Message sent successfully!')
  }

  return (
    <div className="bg-gray-50 py-16 px-2 sm:px-6 lg:px-8">
      <div className="containers">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">

          {/* Left Section */}
          <div className="space-y-8">
            {/* Header */}
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Edit3 className="w-6 h-6 text-blue-600" />
                </div>
                <span className="text-[#1C74BB] font-medium text-lg">Let's Talk With Us</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Grow Your Business With Our Expertise
              </h2>

              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                System is a term used to refer to an organized collection symbols and
                processes that may be used to operate on such symbols
              </p>
            </div>

            {/* Business Meeting Image */}
            <div className="relative">
              <img
                src={require('../../../Img/Untitled design.jpg')}
                alt="Business Meeting"
                className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
            </div>

            {/* Contact Information */}
            {/* I've adjusted the grid to center the single contact card. */}
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 max-w-2xl mx-auto">
              {/* India Office (Surat) */}
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-blue-600">India Office (Surat)</h3>

                <div className="space-y-3">
                  <div className="flex items-start space-x-3 text-gray-600">
                    <MapPin className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
                    <span>402, Empire State Building, Near Udhna Darwaja, Surat, Gujarat - 395002</span>
                  </div>

                  <div className="flex items-center space-x-3 text-gray-600">
                    <Phone className="w-5 h-5 text-gray-400" />
                    {/* Please replace this placeholder with your final number */}
                    <span>+91 98251 31393</span>
                  </div>

                  <div className="flex items-center space-x-3 text-gray-600">
                    <Mail className="w-5 h-5 text-gray-400" />
                    <a href="mailto:info@dynamicsoftlink.com" className="text-blue-600 hover:underline">
                      info@dynamicsoftlink.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Contact Form */}
          <div className="bg-white rounded-lg shadow-lg p-2 lg:p-10">
            {/* Blue Header Bar */}
            <div className="w-full h-1 bg-blue-600 rounded-t-lg -mt-8 lg:-mt-10 mb-8"></div>

            <div className="space-y-6">
              {/* Name Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <User className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First Name"
                    className="w-full pl-10 pr-4 py-4 bg-gray-50 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-300 text-gray-900 placeholder-gray-500"
                    required
                  />
                </div>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <User className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last Name"
                    className="w-full pl-10 pr-4 py-4 bg-gray-50 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-300 text-gray-900 placeholder-gray-500"
                    required
                  />
                </div>
              </div>

              {/* Email Field */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="w-full pl-10 pr-4 py-4 bg-gray-50 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-300 text-gray-900 placeholder-gray-500"
                  required
                />
              </div>

              {/* Phone Field */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Phone className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="w-full pl-10 pr-4 py-4 bg-gray-50 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-300 text-gray-900 placeholder-gray-500"
                />
              </div>

              {/* Company Field */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Building className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Company Name"
                  className="w-full pl-10 pr-4 py-4 bg-gray-50 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-300 text-gray-900 placeholder-gray-500"
                />
              </div>

              {/* Subject Field */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MessageCircle className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Your Subject"
                  className="w-full pl-10 pr-4 py-4 bg-gray-50 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-300 text-gray-900 placeholder-gray-500"
                />
              </div>

              {/* Message Field */}
              <div className="relative">
                <div className="absolute top-4 left-3 pointer-events-none">
                  <Edit3 className="h-5 w-5 text-gray-400" />
                </div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Write Your Message"
                  rows={6}
                  className="w-full pl-10 pr-4 py-4 bg-gray-50 border-0 rounded-lg focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-300 text-gray-900 placeholder-gray-500 resize-none"
                  required
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
                type="button"
                onClick={handleSubmit}
                className="w-full bg-[#1C74BB] text-white font-semibold py-4 px-6 rounded-lg transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-lg hover:shadow-xl"
              >
                Send a Message
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactForm